"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ERC721 = void 0;
var ERC721v3Abi_json_1 = __importDefault(require("./ERC721v3Abi.json"));
exports.ERC721 = ERC721v3Abi_json_1.default;
